import { useEffect, useState } from 'react';
import type { Operaciones } from '../../api/operaciones';

/**
 * El país del negocio (`Business.country`, getBusiness) para poner el prefijo al móvil escrito sin él en la Taquilla (G975,
 * ADR-0247). El último leído se recuerda en memoria por negocio para usarlo también sin conexión (la tablet lo lee al abrir
 * la Puerta o la Taquilla con conexión). Sin poder leerlo, null: el móvil va tal cual se escribió.
 */
const recordados = new Map<string, string>();

export async function paisDelNegocio(ops: Pick<Operaciones, 'getBusiness'>, negocio: string): Promise<string | null> {
    try {
        const { country } = await ops.getBusiness(negocio);
        recordados.set(negocio, country);
        return country;
    } catch {
        return recordados.get(negocio) ?? null;
    }
}

export function usePaisDelNegocio(ops: Pick<Operaciones, 'getBusiness'>, negocio: string, conConexion: boolean): string | null {
    const [pais, setPais] = useState<{ negocio: string; pais: string | null } | null>(null);
    useEffect(() => {
        if (!conConexion) {
            return;
        }
        let vivo = true;
        void paisDelNegocio(ops, negocio).then((p) => { if (vivo) { setPais({ negocio, pais: p }); } });
        return () => { vivo = false; };
    }, [ops, negocio, conConexion]);
    return (pais?.negocio === negocio ? pais.pais : null) ?? recordados.get(negocio) ?? null;
}
